import $pageConfig from "webutils/services/page-config";
const verbs = ["From", "To"];

export default class AutoQueryNumberFilter {
  constructor(config, $aq) {
    const g = this;
    const fieldName = config.fieldName || config.number || config.toString();
    Object.assign(g, config);
    g.verbs = verbs;
    g.type = "number";
    g.query = $aq;
    g.bus = $aq.bus;
    g.fieldName = fieldName;
    g.title = config.title || fieldName;
  }

  search(value) {
    const $ctrl = this;
    $ctrl.query.load(true);
    this.query.scrollTop && $pageConfig && $pageConfig.goTop();
  }

  readQueryString(fieldName, value) {
    const g = this;
    verbs.forEach((v) => {
      if (fieldName.toLowerCase() == (v + g.fieldName).toLowerCase()) {
        g.query.criteria[v + g.fieldName] = value;
      }
    });
  }

  writeQueryString(params) {
    const g = this;
    verbs
      .filter((v) => g.query.criteria[v + g.fieldName])
      .forEach(
        (v) => (params[v + g.fieldName] = g.query.criteria[v + g.fieldName])
      );
  }

  clear(load) {
    const g = this;
    for (const fieldName in g.query.criteria) {
      verbs.forEach((v) => {
        if (fieldName.toLowerCase() == (v + g.fieldName).toLowerCase()) {
          delete g.query.criteria[v + g.fieldName];
        }
      });
    }
    load && g.query.load(true);
  }

  getRefinements() {
    const g = this;
    let results = [];
    verbs
      .filter((v) => g.query.criteria[v + g.fieldName])
      .forEach((v) =>
        results.push({
          label: g.title + " " + v + " " + g.query.criteria[v + g.fieldName],
          remove: () => {
            delete g.query.criteria[v + g.fieldName];
            g.query.load(true);
          },
        })
      );
    return results;
  }
}
